/**
 * Μέγεθος Επιχείρησης
 */
export const CompanySizeOptions = {
  Small: 'Μικρό Μέγεθος',
  Medium: 'Μεσαίο Μέγεθος',
  Large: 'Μεγάλο Μέγεθος',
};

/**
 * Νομική μορφή
 */
export const LegalFormOptions = {
  SP: 'ΑΤΟΜΙΚΗ',
  GP: 'ΟΜΟΡΡΥΘΜΗ ΕΤΑΙΡΕΙΑ',
  LP: 'ΕΤΕΡΟΡΡΥΘΜΗ ΕΤΑΙΡΕΙΑ',
  LLC: 'ΕΤΑΙΡΕΙΑ ΠΕΡΙΟΡΙΣΜΕΝΗΣ ΕΥΘΥΝΗΣ',
  PC: 'ΙΔΙΩΤΙΚΗ ΚΕΦΑΛΑΙΟΥΧΙΚΗ ΕΤΑΙΡΕΙΑ',
  PLC: 'ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ',
  SC: 'ΚΟΙΝΩΝΙΚΗ ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΕΠΙΧΕΙΡΗΣΗ',
  OTHER: 'ΑΛΛΟ',
};

/**
 * Κατάσταση προγραμμάτων
 */
export const ProgramFilterStatus = {
  OPEN_PROGRAM: {
    backendKey: 'OPEN_PROGRAM',
    label: 'Ανοιχτά Προγράμματα',
    value: 'openProgram',
  },
  CLOSE_TO_EXPIRE: {
    backendKey: 'CLOSE_TO_EXPIRE',
    label: 'Προγράμματα που λήγουν σύντομα',
    value: 'closeToExpire',
  },
  EXPIRED: {
    backendKey: 'EXPIRED',
    label: 'Προγράμματα που έχουν λήξει',
    value: 'expired',
  },
  // FUNDING_INSIGHTS: {
  //   backendKey: 'FUNDING_INSIGHTS',
  //   label: 'Grant Thornton Insights',
  //   value: 'fundingInsights',
  // },
};

/**
 * Πηγή Χρηματότησης
 */
export const FundingSource = {
  ESPA: {
    backendKey: 'ESPA',
    label: 'ΕΣΠΑ',
    value: 'espa',
    actionType: 'TOGGLE_ESPA',
  },
  RESILIENCE: {
    backendKey: 'TAA',
    label: 'Ταμείο Ανάκαμψης και Ανθεκτικότητας',
    value: 'taa',
    actionType: 'TOGGLE_TAA',
  },
};

/**
 * Δραστηριότητες Επένδυσης
 */
export const InvestmentActivity = {
  AGRICULTURE_FORESTRY_FISHING: {
    backendKey: 'Α',
    label: 'Γεωργία, δασοκομία και αλιεία',
    value: 'activityCheck1',
    actionType: 'TOGGLE_ACTIVITY_CHECK1',
  },
  MINING_QUARRYING: {
    backendKey: 'Β',
    label: 'Ορυχεία και λατομεία',
    value: 'activityCheck2',
    actionType: 'TOGGLE_ACTIVITY_CHECK2',
  },
  MANUFACTURING: {
    backendKey: 'Γ',
    label: 'Μεταποίηση',
    value: 'activityCheck3',
    actionType: 'TOGGLE_ACTIVITY_CHECK3',
  },
  ELECTRICITY_GAS_STEAM_AIR_CONDITIONING: {
    backendKey: 'Δ',
    label: 'Παροχή ηλεκτρικού ρεύματος, φυσικού αερίου, ατμού και κλιματισμού',
    value: 'activityCheck4',
    actionType: 'TOGGLE_ACTIVITY_CHECK4',
  },
  WATER_SEWERAGE_WASTE_MANAGEMENT: {
    backendKey: 'Ε',
    label:
      'Παροχή νερού, επεξεργασία λυμάτων, διαχείριση αποβλήτων και δραστηριότητες εξυγίανσης',
    value: 'activityCheck5',
    actionType: 'TOGGLE_ACTIVITY_CHECK5',
  },
  CONSTRUCTION: {
    backendKey: 'ΣΤ',
    label: 'Κατασκευές',
    value: 'activityCheck6',
    actionType: 'TOGGLE_ACTIVITY_CHECK6',
  },
  WHOLESALE_RETAIL_TRADE_REPAIR: {
    backendKey: 'Ζ',
    label: 'Χονδρικό και λιανικό εμπόριο, επισκευή οχημάτων και μοτοσικλετών',
    value: 'activityCheck7',
    actionType: 'TOGGLE_ACTIVITY_CHECK7',
  },
  TRANSPORTATION_STORAGE: {
    backendKey: 'Η',
    label: 'Μεταφορά και αποθήκευση',
    value: 'activityCheck8',
    actionType: 'TOGGLE_ACTIVITY_CHECK8',
  },
  ACCOMMODATION_FOOD_SERVICE: {
    backendKey: 'Θ',
    label: 'Υπηρεσίες καταλύματος και εστίασης',
    value: 'activityCheck9',
    actionType: 'TOGGLE_ACTIVITY_CHECK9',
  },
  INFORMATION_COMMUNICATION: {
    backendKey: 'Ι',
    label: 'Ενημέρωση και επικοινωνία',
    value: 'activityCheck10',
    actionType: 'TOGGLE_ACTIVITY_CHECK10',
  },
  FINANCIAL_INSURANCE: {
    backendKey: 'ΙΑ',
    label: 'Χρηματοπιστωτικές και ασφαλιστικές δραστηριότητες',
    value: 'activityCheck11',
    actionType: 'TOGGLE_ACTIVITY_CHECK11',
  },
  REAL_ESTATE: {
    backendKey: 'ΙΒ',
    label: 'Διαχείριση ακίνητης περιουσίας',
    value: 'activityCheck12',
    actionType: 'TOGGLE_ACTIVITY_CHECK12',
  },
  PROFESSIONAL_SCIENTIFIC_TECHNICAL: {
    backendKey: 'ΙΓ',
    label: 'Επαγγελματικές, επιστημονικές και τεχνικές δραστηριότητες',
    value: 'activityCheck13',
    actionType: 'TOGGLE_ACTIVITY_CHECK13',
  },
  ADMINISTRATIVE_SUPPORT: {
    backendKey: 'ΙΔ',
    label: 'Διοικητικές και υποστηρικτικές δραστηριότητες',
    value: 'activityCheck14',
    actionType: 'TOGGLE_ACTIVITY_CHECK14',
  },
  PUBLIC_ADMINISTRATION_DEFENSE: {
    backendKey: 'ΙΕ',
    label: 'Δημόσια διοίκηση και άμυνα, υποχρεωτική κοινωνική ασφάλιση',
    value: 'activityCheck15',
    actionType: 'TOGGLE_ACTIVITY_CHECK15',
  },
  EDUCATION: {
    backendKey: 'ΙΣΤ',
    label: 'Εκπαίδευση',
    value: 'activityCheck16',
    actionType: 'TOGGLE_ACTIVITY_CHECK16',
  },
  HEALTH_SOCIAL_WORK: {
    backendKey: 'ΙΖ',
    label: 'Υγεία και κοινωνική μέριμνα',
    value: 'activityCheck17',
    actionType: 'TOGGLE_ACTIVITY_CHECK17',
  },
  ARTS_ENTERTAINMENT_RECREATION: {
    backendKey: 'ΙΗ',
    label: 'Τέχνες, διασκέδαση και ψυχαγωγία',
    value: 'activityCheck18',
    actionType: 'TOGGLE_ACTIVITY_CHECK18',
  },
  OTHER_SERVICE_ACTIVITIES: {
    backendKey: 'ΙΘ',
    label: 'Άλλες δραστηριότητες παροχής υπηρεσιών',
    value: 'activityCheck19',
    actionType: 'TOGGLE_ACTIVITY_CHECK19',
  },
  HOUSEHOLDS_AS_EMPLOYERS: {
    backendKey: 'Κ',
    label: 'Δραστηριότητες νοικοκυριών ως εργοδοτών',
    value: 'activityCheck20',
    actionType: 'TOGGLE_ACTIVITY_CHECK20',
  },
  EXTRATERRITORIAL_ORGANIZATIONS: {
    backendKey: 'ΚΑ',
    label: 'Δραστηριότητες εξωχωρίων οργανισμών και φορέων',
    value: 'activityCheck21',
    actionType: 'TOGGLE_ACTIVITY_CHECK21',
  },
  NO_ACTIVITY: {
    backendKey: 'ΚΒ',
    label: 'Έλλειψη δραστηριότητας',
    value: 'activityCheck22',
    actionType: 'TOGGLE_ACTIVITY_CHECK22',
  },
};

/**
 * Δαπάνες
 */
export const EligibleExpense = {
  ANALOSIMA: {
    backendKey: 'ANALOSIMA',
    label: 'Αναλώσιμα',
    value: 'expenseCheck1',
    actionType: 'TOGGLE_EXPENSE_CHECK1',
  },
  AULA: {
    backendKey: 'AULA',
    label: 'Άυλα αγορά, Άυλα χρήση (αποσβέσεις/συνδρομές)',
    value: 'expenseCheck2',
    actionType: 'TOGGLE_EXPENSE_CHECK2',
  },
  GIPEDA_AGORA: {
    backendKey: 'GIPEDA_AGORA',
    label: 'Γήπεδα αγορά',
    value: 'expenseCheck3',
    actionType: 'TOGGLE_EXPENSE_CHECK3',
  },
  GIPEDA_XRISI: {
    backendKey: 'GIPEDA_XRISI',
    label: 'Γήπεδα χρήση (αποσβέσεις/μισθώσεις), Διαμόρφωση γηπέδων',
    value: 'expenseCheck4',
    actionType: 'TOGGLE_EXPENSE_CHECK4',
  },
  MARKETING: {
    backendKey: 'MARKETING',
    label: 'Δαπάνες προώθησης και επικοινωνίας (Marketing)',
    value: 'expenseCheck5',
    actionType: 'TOGGLE_EXPENSE_CHECK5',
  },
  EXOPLISMOS: {
    backendKey: 'EXOPLISMOS',
    label:
      'Εξοπλισμός αγορά/κατασκευή, Εξοπλισμός χρήση (αποσβέσεις/μισθώσεις)',
    value: 'expenseCheck6',
    actionType: 'TOGGLE_EXPENSE_CHECK6',
  },
  KEFALAIO_KINISIS: {
    backendKey: 'KEFALAIO_KINISIS',
    label:
      'Κεφάλαιο κίνησης (δαπάνες λειτουργίας, δαπάνες σχετικές με το συναλλακτικό κύκλωμα της επιχείρησης, ΦΠΑ, κ.λπ.)',
    value: 'expenseCheck7',
    actionType: 'TOGGLE_EXPENSE_CHECK7',
  },
  KOSTOS_KEFALAION: {
    backendKey: 'KOSTOS_KEFALAION',
    label: 'Κόστος κεφαλαίων',
    value: 'expenseCheck8',
    actionType: 'TOGGLE_EXPENSE_CHECK8',
  },
  KTHRIA_AGORA: {
    backendKey: 'KTHRIA_AGORA',
    label: 'Κτήρια αγορά / κατασκευή, Κτήρια χρήση (αποσβέσεις/μισθώσεις)',
    value: 'expenseCheck9',
    actionType: 'TOGGLE_EXPENSE_CHECK9',
  },
  LEITOURGIKA: {
    backendKey: 'LEITOURGIKA',
    label:
      'Λειτουργικά (επικοινωνία, ενέργεια, συντήρηση, μισθώματα, έξοδα διοίκησης, ασφάλιση κ.λπ..)',
    value: 'expenseCheck10',
    actionType: 'TOGGLE_EXPENSE_CHECK10',
  },
  METAKINISEIS: {
    backendKey: 'METAKINISEIS',
    label: 'Μετακινήσεις / εξοδολόγια',
    value: 'expenseCheck11',
    actionType: 'TOGGLE_EXPENSE_CHECK11',
  },
  METAFORIKA_MESA: {
    backendKey: 'METAFORIKA_MESA',
    label:
      'Μεταφορικά μέσα αγορά, μεταφορικά μέσα χρήση (αποσβέσεις/μισθώσεις)',
    value: 'expenseCheck12',
    actionType: 'TOGGLE_EXPENSE_CHECK12',
  },
  MISTHODOSIA_GAK: {
    backendKey: 'MISTHODOSIA_GAK',
    label:
      'Μισθοδοσία συνδεδεμένη με το επενδυτικό σχέδιο (όπως προβλέπεται από τον ΓΑΚ)',
    value: 'expenseCheck13',
    actionType: 'TOGGLE_EXPENSE_CHECK13',
  },
  YPHRESIES_TRITON: {
    backendKey: 'YPHRESIES_TRITON',
    label: 'Υπηρεσίες τρίτων',
    value: 'expenseCheck14',
    actionType: 'TOGGLE_EXPENSE_CHECK14',
  },
};

/**
 * Τύπος επιχείρησης
 */
export const CompanyType = {
  EXISTING: 'Υφιστάμενη',
  NEW: 'Νέα',
  UNDER_FORMATION: 'Υπό Σύσταση',
};

/**
 * Είδος ενίσχυσης
 */
export const SubsidyTypeCode = {
  LOAN: {
    backendKey: 'LOAN_INTEREST_SUBSIDY',
    label: 'Δάνειο',
    value: 'subsidyCheck1',
    actionType: 'TOGGLE_SUBSIDY_CHECK1',
  },
  INTEREST_SUBSIDY: {
    backendKey: 'GRANT_SUBSIDY',
    label: 'Επιχορήγηση/Επιδότηση',
    value: 'subsidyCheck2',
    actionType: 'TOGGLE_SUBSIDY_CHECK2',
  },
};

/**
 * Καθεστώς ενίσχυσης
 */
export const LawCode = {
  GAK: 'ΓΑΚ',
  DEMINIMIS: 'De Minimis',
};

/**
 * Άρθρο για το καθεστώς ενίσχυσης
 */
export const ArticleCode = {
  A7: '7',
  A14: '14',
  A16: '16',
  A25: '25',
  A42: '42',
};

export const ProgramFilterStatusBackEndKey = {
  ClosingSoon: 'closingSoonPrograms',
  Expired: 'expiredPrograms',
  // Insights: 'gtInsightsPrograms',
  Open: 'openPrograms',
};
